import { SizedCell } from 'components/Kizen/Table/CellLineHeightStyles';
import {
  columnSize,
  paddingSize,
  CreatedCell,
  TypeCell,
  NumberCompletedCell,
  NumberPausedCell,
  NumberActiveCell,
  ObjectNameCell,
  StatusCell,
  NameCell,
  ActionCell,
  ResizableHeadCell,
} from './Cells';

// Note: `cell` is cloned by the table component and adds the `head`, `column`, and `data` props.
export const getAutomationsColumns = ({
  currentDirectory,
  onUpdateAutomation,
  onSelectAction,
  onChangeDirectory,
  canEdit,
  canDelete,
  t,
}) => [
  {
    id: 'spacer-1',
    headCell: <SizedCell width={columnSize.spacer} />,
    cell: <SizedCell width={columnSize.spacer} />,
  },
  {
    id: 'name',
    headCell: <ResizableHeadCell label={t('Name')} padding={paddingSize.big} />,
    cell: (
      <NameCell
        onUpdateAutomation={onUpdateAutomation}
        onChangeDirectory={onChangeDirectory}
      />
    ),
  },
  {
    id: 'customObjectName',
    headCell: (
      <ResizableHeadCell label={t('Object')} padding={paddingSize.big} />
    ),
    cell: <ObjectNameCell />,
  },
  {
    id: 'status',
    headCell: (
      <ResizableHeadCell label={t('Status')} padding={paddingSize.big} />
    ),
    cell: (
      <StatusCell onUpdateAutomation={onUpdateAutomation} canEdit={canEdit} />
    ),
  },
  {
    id: 'numberActive',
    headCell: (
      <ResizableHeadCell
        numeric
        label={t('# Active')}
        padding={paddingSize.big}
      />
    ),
    cell: <NumberActiveCell />,
  },
  {
    id: 'numberPaused',
    headCell: (
      <ResizableHeadCell
        numeric
        label={t('# Paused')}
        padding={paddingSize.big}
      />
    ),
    cell: <NumberPausedCell />,
  },
  {
    id: 'numberCompleted',
    headCell: (
      <ResizableHeadCell
        numeric
        label={t('# Completed')}
        padding={paddingSize.big}
      />
    ),
    cell: <NumberCompletedCell />,
  },
  {
    id: 'type',
    headCell: <ResizableHeadCell label={t('Type')} padding={paddingSize.big} />,
    cell: <TypeCell />,
  },
  {
    id: 'created',
    headCell: (
      <ResizableHeadCell
        numeric
        label={t('Date Created')}
        padding={paddingSize.big}
      />
    ),
    cell: <CreatedCell />,
  },
  {
    id: 'actions',
    headCell: (
      <SizedCell width={columnSize.actions} padding={paddingSize.small} />
    ),
    cell: (
      <ActionCell
        onSelectAction={onSelectAction}
        currentDirectory={currentDirectory}
        canEdit={canEdit}
        canDelete={canDelete}
      />
    ),
  },
];
